import { DreamBlock } from '@typedream/core';
import { toDOMNode } from '@udecode/plate-core';
import { DreamEditor } from '../types';

export const getElementDomRect = (editor: DreamEditor, element: DreamBlock) => {
  const domNode = toDOMNode(editor, element);
  if (!domNode) return null;
  return domNode.getBoundingClientRect();
};
